export default {
  name: 'Ik Wil App',
  storeName: 'ikwil-app',
  description: 'Data for Ik Wil App',
  version: 1.0,
}
